module.exports = "/app/main/img/default.b507fb58.png";